let z = !1;
const D = [], V = (n) => new Promise((e, t) => {
  if (typeof window > "u" || (window.storyblokRegisterEvent = (s) => {
    if (window.location === window.parent.location) {
      console.warn("You are not in Draft Mode or in the Visual Editor.");
      return;
    }
    z ? s() : D.push(s);
  }, document.getElementById("storyblok-javascript-bridge")))
    return;
  const r = document.createElement("script");
  r.async = !0, r.src = n, r.id = "storyblok-javascript-bridge", r.onerror = (s) => t(s), r.onload = (s) => {
    D.forEach((o) => o()), z = !0, e(s);
  }, document.getElementsByTagName("head")[0].appendChild(r);
});
var ne = Object.defineProperty, oe = (n, e, t) => e in n ? ne(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, m = (n, e, t) => oe(n, typeof e != "symbol" ? e + "" : e, t);
class ae extends Error {
  constructor(e) {
    super(e), this.name = "AbortError";
  }
}
function ie(n, e, t) {
  if (!Number.isFinite(e))
    throw new TypeError("Expected `limit` to be a finite number");
  if (!Number.isFinite(t))
    throw new TypeError("Expected `interval` to be a finite number");
  const r = [];
  let s = [], o = 0, a = !1;
  const l = async () => {
    o++;
    const h = r.shift();
    if (h)
      try {
        const p = await n(...h.args);
        h.resolve(p);
      } catch (p) {
        h.reject(p);
      }
    const d = setTimeout(() => {
      o--, r.length > 0 && l(), s = s.filter((p) => p !== d);
    }, t);
    s.includes(d) || s.push(d);
  }, i = (...h) => a ? Promise.reject(
    new Error(
      "Throttled function is already aborted and not accepting new promises"
    )
  ) : new Promise((d, p) => {
    r.push({
      resolve: d,
      reject: p,
      args: h
    }), o < e && l();
  });
  return i.abort = () => {
    a = !0, s.forEach(clearTimeout), s = [], r.forEach(
      (h) => h.reject(() => new ae("Throttle function aborted"))
    ), r.length = 0;
  }, i;
}
class C {
  constructor() {
    m(this, "isCDNUrl", (e = "") => e.includes("/cdn/")), m(this, "getOptionsPage", (e, t = 25, r = 1) => ({
      ...e,
      per_page: t,
      page: r
    })), m(this, "delay", (e) => new Promise((t) => setTimeout(t, e))), m(this, "arrayFrom", (e = 0, t) => Array.from({ length: e }, t)), m(this, "range", (e = 0, t = e) => {
      const r = Math.abs(t - e) || 0, s = e < t ? 1 : -1;
      return this.arrayFrom(r, (o, a) => a * s + e);
    }), m(this, "asyncMap", async (e, t) => Promise.all(e.map(t))), m(this, "flatMap", (e = [], t) => e.map(t).reduce((r, s) => [...r, ...s], [])), m(this, "escapeHTML", function(e) {
      const t = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, r = /[&<>"']/g, s = new RegExp(r.source);
      return e && s.test(e) ? e.replace(r, (o) => t[o]) : e;
    });
  }
  /**
   * @method stringify
   * @param  {object} params
   * @param  {string} prefix
   * @param  {boolean} isArray
   * @return {string} Stringified object
   */
  stringify(e, t, r) {
    const s = [];
    for (const o in e) {
      if (!Object.prototype.hasOwnProperty.call(e, o))
        continue;
      const a = e[o];
      if (a == null)
        continue;
      const l = r ? "" : encodeURIComponent(o);
      let i;
      typeof a == "object" ? i = this.stringify(
        a,
        t ? t + encodeURIComponent(`[${l}]`) : l,
        Array.isArray(a)
      ) : i = `${t ? t + encodeURIComponent(`[${l}]`) : l}=${encodeURIComponent(a)}`, s.push(i);
    }
    return s.join("&");
  }
  /**
   * @method getRegionURL
   * @param  {string} regionCode region code, could be eu, us, cn, ap or ca
   * @return {string} The base URL of the region
   */
  getRegionURL(e) {
    const t = "api.storyblok.com", r = "api-us.storyblok.com", s = "app.storyblokchina.cn", o = "api-ap.storyblok.com", a = "api-ca.storyblok.com";
    switch (e) {
      case "us":
        return r;
      case "cn":
        return s;
      case "ap":
        return o;
      case "ca":
        return a;
      default:
        return t;
    }
  }
}
const le = function(n, e) {
  const t = {};
  for (const r in n) {
    const s = n[r];
    e.includes(r) && s !== null && (t[r] = s);
  }
  return t;
}, ce = (n) => n === "email", he = () => ({
  singleTag: "hr"
}), ue = () => ({
  tag: "blockquote"
}), de = () => ({
  tag: "ul"
}), pe = (n) => ({
  tag: [
    "pre",
    {
      tag: "code",
      attrs: n.attrs
    }
  ]
}), ge = () => ({
  singleTag: "br"
}), fe = (n) => ({
  tag: `h${n.attrs.level}`
}), me = (n) => ({
  singleTag: [
    {
      tag: "img",
      attrs: le(n.attrs, ["src", "alt", "title"])
    }
  ]
}), ye = () => ({
  tag: "li"
}), be = () => ({
  tag: "ol"
}), ve = () => ({
  tag: "p"
}), ke = (n) => ({
  tag: [
    {
      tag: "span",
      attrs: {
        "data-type": "emoji",
        "data-name": n.attrs.name,
        emoji: n.attrs.emoji
      }
    }
  ]
}), Te = () => ({
  tag: "b"
}), we = () => ({
  tag: "s"
}), $e = () => ({
  tag: "u"
}), Re = () => ({
  tag: "strong"
}), _e = () => ({
  tag: "code"
}), Ee = () => ({
  tag: "i"
}), Se = (n) => {
  if (!n.attrs)
    return {
      tag: ""
    };
  const e = new C().escapeHTML, t = { ...n.attrs }, { linktype: r = "url" } = n.attrs;
  if (delete t.linktype, t.href && (t.href = e(n.attrs.href || "")), ce(r) && (t.href = `mailto:${t.href}`), t.anchor && (t.href = `${t.href}#${t.anchor}`, delete t.anchor), t.custom) {
    for (const s in t.custom)
      t[s] = t.custom[s];
    delete t.custom;
  }
  return {
    tag: [
      {
        tag: "a",
        attrs: t
      }
    ]
  };
}, je = (n) => ({
  tag: [
    {
      tag: "span",
      attrs: n.attrs
    }
  ]
}), xe = () => ({
  tag: "sub"
}), Ie = () => ({
  tag: "sup"
}), Ae = (n) => ({
  tag: [
    {
      tag: "span",
      attrs: n.attrs
    }
  ]
}), Oe = (n) => {
  var e;
  return (e = n.attrs) != null && e.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `background-color:${n.attrs.color};`
        }
      }
    ]
  } : {
    tag: ""
  };
}, Le = (n) => {
  var e;
  return (e = n.attrs) != null && e.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `color:${n.attrs.color}`
        }
      }
    ]
  } : {
    tag: ""
  };
}, Ce = {
  nodes: {
    horizontal_rule: he,
    blockquote: ue,
    bullet_list: de,
    code_block: pe,
    hard_break: ge,
    heading: fe,
    image: me,
    list_item: ye,
    ordered_list: be,
    paragraph: ve,
    emoji: ke
  },
  marks: {
    bold: Te,
    strike: we,
    underline: $e,
    strong: Re,
    code: _e,
    italic: Ee,
    link: Se,
    styled: je,
    subscript: xe,
    superscript: Ie,
    anchor: Ae,
    highlight: Oe,
    textStyle: Le
  }
}, Pe = function(n) {
  const e = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  }, t = /[&<>"']/g, r = new RegExp(t.source);
  return n && r.test(n) ? n.replace(t, (s) => e[s]) : n;
};
let q = !1;
class P {
  constructor(e) {
    m(this, "marks"), m(this, "nodes"), e || (e = Ce), this.marks = e.marks || [], this.nodes = e.nodes || [];
  }
  addNode(e, t) {
    this.nodes[e] = t;
  }
  addMark(e, t) {
    this.marks[e] = t;
  }
  render(e, t = { optimizeImages: !1 }, r = !0) {
    if (!q && r && (console.warn(
      "Warning ⚠️: The RichTextResolver class is deprecated and will be removed in the next major release. Please use the `@storyblok/richtext` package instead. https://github.com/storyblok/richtext/"
    ), q = !0), e && e.content && Array.isArray(e.content)) {
      let s = "";
      return e.content.forEach((o) => {
        s += this.renderNode(o);
      }), t.optimizeImages ? this.optimizeImages(s, t.optimizeImages) : s;
    }
    return console.warn(
      `The render method must receive an Object with a "content" field.
      The "content" field must be an array of nodes as the type ISbRichtext.
      ISbRichtext:
        content?: ISbRichtext[]
        marks?: ISbRichtext[]
        attrs?: any
        text?: string
        type: string
        
        Example:
        {
          content: [
            {
              content: [
                {
                  text: 'Hello World',
                  type: 'text'
                }
              ],
              type: 'paragraph'
            }
          ],
          type: 'doc'
        }`
    ), "";
  }
  optimizeImages(e, t) {
    let r = 0, s = 0, o = "", a = "";
    typeof t != "boolean" && (typeof t.width == "number" && t.width > 0 && (o += `width="${t.width}" `, r = t.width), typeof t.height == "number" && t.height > 0 && (o += `height="${t.height}" `, s = t.height), (t.loading === "lazy" || t.loading === "eager") && (o += `loading="${t.loading}" `), typeof t.class == "string" && t.class.length > 0 && (o += `class="${t.class}" `), t.filters && (typeof t.filters.blur == "number" && t.filters.blur >= 0 && t.filters.blur <= 100 && (a += `:blur(${t.filters.blur})`), typeof t.filters.brightness == "number" && t.filters.brightness >= -100 && t.filters.brightness <= 100 && (a += `:brightness(${t.filters.brightness})`), t.filters.fill && (t.filters.fill.match(/[0-9A-F]{6}/gi) || t.filters.fill === "transparent") && (a += `:fill(${t.filters.fill})`), t.filters.format && ["webp", "png", "jpeg"].includes(t.filters.format) && (a += `:format(${t.filters.format})`), typeof t.filters.grayscale == "boolean" && t.filters.grayscale && (a += ":grayscale()"), typeof t.filters.quality == "number" && t.filters.quality >= 0 && t.filters.quality <= 100 && (a += `:quality(${t.filters.quality})`), t.filters.rotate && [90, 180, 270].includes(t.filters.rotate) && (a += `:rotate(${t.filters.rotate})`), a.length > 0 && (a = `/filters${a}`))), o.length > 0 && (e = e.replace(/<img/g, `<img ${o.trim()}`));
    const l = r > 0 || s > 0 || a.length > 0 ? `${r}x${s}${a}` : "";
    return e = e.replace(
      /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g,
      `a.storyblok.com/f/$1/$2.$3/m/${l}`
    ), typeof t != "boolean" && (t.sizes || t.srcset) && (e = e.replace(/<img.*?src=["|'](.*?)["|']/g, (i) => {
      var h, d;
      const p = i.match(
        /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|bmp)/g
      );
      if (p && p.length > 0) {
        const b = {
          srcset: (h = t.srcset) == null ? void 0 : h.map((y) => {
            if (typeof y == "number")
              return `//${p}/m/${y}x0${a} ${y}w`;
            if (typeof y == "object" && y.length === 2) {
              let S = 0, I = 0;
              return typeof y[0] == "number" && (S = y[0]), typeof y[1] == "number" && (I = y[1]), `//${p}/m/${S}x${I}${a} ${S}w`;
            }
            return "";
          }).join(", "),
          sizes: (d = t.sizes) == null ? void 0 : d.map((y) => y).join(", ")
        };
        let E = "";
        return b.srcset && (E += `srcset="${b.srcset}" `), b.sizes && (E += `sizes="${b.sizes}" `), i.replace(/<img/g, `<img ${E.trim()}`);
      }
      return i;
    })), e;
  }
  renderNode(e) {
    const t = [];
    e.marks && e.marks.forEach((s) => {
      const o = this.getMatchingMark(s);
      o && o.tag !== "" && t.push(this.renderOpeningTag(o.tag));
    });
    const r = this.getMatchingNode(e);
    return r && r.tag && t.push(this.renderOpeningTag(r.tag)), e.content ? e.content.forEach((s) => {
      t.push(this.renderNode(s));
    }) : e.text ? t.push(Pe(e.text)) : r && r.singleTag ? t.push(this.renderTag(r.singleTag, " /")) : r && r.html ? t.push(r.html) : e.type === "emoji" && t.push(this.renderEmoji(e)), r && r.tag && t.push(this.renderClosingTag(r.tag)), e.marks && e.marks.slice(0).reverse().forEach((s) => {
      const o = this.getMatchingMark(s);
      o && o.tag !== "" && t.push(this.renderClosingTag(o.tag));
    }), t.join("");
  }
  renderTag(e, t) {
    return e.constructor === String ? `<${e}${t}>` : e.map((r) => {
      if (r.constructor === String)
        return `<${r}${t}>`;
      {
        let s = `<${r.tag}`;
        if (r.attrs) {
          for (const o in r.attrs)
            if (Object.prototype.hasOwnProperty.call(r.attrs, o)) {
              const a = r.attrs[o];
              a !== null && (s += ` ${o}="${a}"`);
            }
        }
        return `${s}${t}>`;
      }
    }).join("");
  }
  renderOpeningTag(e) {
    return this.renderTag(e, "");
  }
  renderClosingTag(e) {
    return e.constructor === String ? `</${e}>` : e.slice(0).reverse().map((t) => t.constructor === String ? `</${t}>` : `</${t.tag}>`).join("");
  }
  getMatchingNode(e) {
    const t = this.nodes[e.type];
    if (typeof t == "function")
      return t(e);
  }
  getMatchingMark(e) {
    const t = this.marks[e.type];
    if (typeof t == "function")
      return t(e);
  }
  renderEmoji(e) {
    if (e.attrs.emoji)
      return e.attrs.emoji;
    const t = [
      {
        tag: "img",
        attrs: {
          src: e.attrs.fallbackImage,
          draggable: "false",
          loading: "lazy",
          align: "absmiddle"
        }
      }
    ];
    return this.renderTag(t, " /");
  }
}
class Ne {
  constructor(e) {
    m(this, "baseURL"), m(this, "timeout"), m(this, "headers"), m(this, "responseInterceptor"), m(this, "fetch"), m(this, "ejectInterceptor"), m(this, "url"), m(this, "parameters"), m(this, "fetchOptions"), this.baseURL = e.baseURL, this.headers = e.headers || new Headers(), this.timeout = e != null && e.timeout ? e.timeout * 1e3 : 0, this.responseInterceptor = e.responseInterceptor, this.fetch = (...t) => e.fetch ? e.fetch(...t) : fetch(...t), this.ejectInterceptor = !1, this.url = "", this.parameters = {}, this.fetchOptions = {};
  }
  /**
   *
   * @param url string
   * @param params ISbStoriesParams
   * @returns Promise<ISbResponse | Error>
   */
  get(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("get");
  }
  post(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("post");
  }
  put(e, t) {
    return this.url = e, this.parameters = t, this._methodHandler("put");
  }
  delete(e, t) {
    return this.url = e, this.parameters = t ?? {}, this._methodHandler("delete");
  }
  async _responseHandler(e) {
    const t = [], r = {
      data: {},
      headers: {},
      status: 0,
      statusText: ""
    };
    e.status !== 204 && await e.json().then((s) => {
      r.data = s;
    });
    for (const s of e.headers.entries())
      t[s[0]] = s[1];
    return r.headers = { ...t }, r.status = e.status, r.statusText = e.statusText, r;
  }
  async _methodHandler(e) {
    let t = `${this.baseURL}${this.url}`, r = null;
    if (e === "get") {
      const i = new C();
      t = `${this.baseURL}${this.url}?${i.stringify(
        this.parameters
      )}`;
    } else
      r = JSON.stringify(this.parameters);
    const s = new URL(t), o = new AbortController(), { signal: a } = o;
    let l;
    this.timeout && (l = setTimeout(() => o.abort(), this.timeout));
    try {
      const i = await this.fetch(`${s}`, {
        method: e,
        headers: this.headers,
        body: r,
        signal: a,
        ...this.fetchOptions
      });
      this.timeout && clearTimeout(l);
      const h = await this._responseHandler(
        i
      );
      return this.responseInterceptor && !this.ejectInterceptor ? this._statusHandler(this.responseInterceptor(h)) : this._statusHandler(h);
    } catch (i) {
      return {
        message: i
      };
    }
  }
  setFetchOptions(e = {}) {
    Object.keys(e).length > 0 && "method" in e && delete e.method, this.fetchOptions = { ...e };
  }
  eject() {
    this.ejectInterceptor = !0;
  }
  _statusHandler(e) {
    const t = /20[0-6]/g;
    return new Promise((r, s) => {
      if (t.test(`${e.status}`))
        return r(e);
      const o = {
        message: e.statusText,
        status: e.status,
        response: Array.isArray(e.data) ? e.data[0] : e.data.error || e.data.slug
      };
      s(o);
    });
  }
}
const F = "SB-Agent", H = {
  defaultAgentName: "SB-JS-CLIENT",
  defaultAgentVersion: "SB-Agent-Version",
  packageVersion: "6.0.0"
};
let O = {};
const j = {};
class He {
  /**
   *
   * @param config ISbConfig interface
   * @param pEndpoint string, optional
   */
  constructor(e, t) {
    m(this, "client"), m(this, "maxRetries"), m(this, "retriesDelay"), m(this, "throttle"), m(this, "accessToken"), m(this, "cache"), m(this, "helpers"), m(this, "resolveCounter"), m(this, "relations"), m(this, "links"), m(this, "richTextResolver"), m(this, "resolveNestedRelations"), m(this, "stringifiedStoriesCache");
    let r = e.endpoint || t;
    if (!r) {
      const a = new C().getRegionURL, l = e.https === !1 ? "http" : "https";
      e.oauthToken ? r = `${l}://${a(e.region)}/v1` : r = `${l}://${a(e.region)}/v2`;
    }
    const s = new Headers();
    s.set("Content-Type", "application/json"), s.set("Accept", "application/json"), e.headers && (e.headers.constructor.name === "Headers" ? e.headers.entries().toArray() : Object.entries(e.headers)).forEach(([a, l]) => {
      s.set(a, l);
    }), s.has(F) || (s.set(F, H.defaultAgentName), s.set(
      H.defaultAgentVersion,
      H.packageVersion
    ));
    let o = 5;
    e.oauthToken && (s.set("Authorization", e.oauthToken), o = 3), e.rateLimit && (o = e.rateLimit), e.richTextSchema ? this.richTextResolver = new P(e.richTextSchema) : this.richTextResolver = new P(), e.componentResolver && this.setComponentResolver(e.componentResolver), this.maxRetries = e.maxRetries || 10, this.retriesDelay = 300, this.throttle = ie(
      this.throttledRequest.bind(this),
      o,
      1e3
    ), this.accessToken = e.accessToken || "", this.relations = {}, this.links = {}, this.cache = e.cache || { clear: "manual" }, this.helpers = new C(), this.resolveCounter = 0, this.resolveNestedRelations = e.resolveNestedRelations || !0, this.stringifiedStoriesCache = {}, this.client = new Ne({
      baseURL: r,
      timeout: e.timeout || 0,
      headers: s,
      responseInterceptor: e.responseInterceptor,
      fetch: e.fetch
    });
  }
  setComponentResolver(e) {
    this.richTextResolver.addNode("blok", (t) => {
      let r = "";
      return t.attrs.body && t.attrs.body.forEach((s) => {
        r += e(s.component, s);
      }), {
        html: r
      };
    });
  }
  parseParams(e) {
    return e.token || (e.token = this.getToken()), e.cv || (e.cv = j[e.token]), Array.isArray(e.resolve_relations) && (e.resolve_relations = e.resolve_relations.join(",")), typeof e.resolve_relations < "u" && (e.resolve_level = 2), e;
  }
  factoryParamOptions(e, t) {
    return this.helpers.isCDNUrl(e) ? this.parseParams(t) : t;
  }
  makeRequest(e, t, r, s, o) {
    const a = this.factoryParamOptions(
      e,
      this.helpers.getOptionsPage(t, r, s)
    );
    return this.cacheResponse(e, a, void 0, o);
  }
  get(e, t, r) {
    t || (t = {});
    const s = `/${e}`, o = this.factoryParamOptions(s, t);
    return this.cacheResponse(s, o, void 0, r);
  }
  async getAll(e, t, r, s) {
    const o = (t == null ? void 0 : t.per_page) || 25, a = `/${e}`.replace(/\/$/, ""), l = r ?? a.substring(a.lastIndexOf("/") + 1), i = 1, h = await this.makeRequest(
      a,
      t,
      o,
      i,
      s
    ), d = h.total ? Math.ceil(h.total / o) : 1, p = await this.helpers.asyncMap(
      this.helpers.range(i, d),
      (b) => this.makeRequest(a, t, o, b + 1, s)
    );
    return this.helpers.flatMap([h, ...p], (b) => Object.values(b.data[l]));
  }
  post(e, t, r) {
    const s = `/${e}`;
    return Promise.resolve(
      this.throttle("post", s, t, r)
    );
  }
  put(e, t, r) {
    const s = `/${e}`;
    return Promise.resolve(
      this.throttle("put", s, t, r)
    );
  }
  delete(e, t, r) {
    t || (t = {});
    const s = `/${e}`;
    return Promise.resolve(
      this.throttle("delete", s, t, r)
    );
  }
  getStories(e, t) {
    return this._addResolveLevel(e), this.get("cdn/stories", e, t);
  }
  getStory(e, t, r) {
    return this._addResolveLevel(t), this.get(`cdn/stories/${e}`, t, r);
  }
  getToken() {
    return this.accessToken;
  }
  ejectInterceptor() {
    this.client.eject();
  }
  _addResolveLevel(e) {
    typeof e.resolve_relations < "u" && (e.resolve_level = 2);
  }
  _cleanCopy(e) {
    return JSON.parse(JSON.stringify(e));
  }
  _insertLinks(e, t, r) {
    const s = e[t];
    s && s.fieldtype === "multilink" && s.linktype === "story" && typeof s.id == "string" && this.links[r][s.id] ? s.story = this._cleanCopy(this.links[r][s.id]) : s && s.linktype === "story" && typeof s.uuid == "string" && this.links[r][s.uuid] && (s.story = this._cleanCopy(this.links[r][s.uuid]));
  }
  /**
   *
   * @param resolveId A counter number as a string
   * @param uuid The uuid of the story
   * @returns string | object
   */
  getStoryReference(e, t) {
    return this.relations[e][t] ? JSON.parse(this.stringifiedStoriesCache[t] || JSON.stringify(this.relations[e][t])) : t;
  }
  /**
   * Resolves a field's value by replacing UUIDs with their corresponding story references
   * @param jtree - The JSON tree object containing the field to resolve
   * @param treeItem - The key of the field to resolve
   * @param resolveId - The unique identifier for the current resolution context
   *
   * This method handles both single string UUIDs and arrays of UUIDs:
   * - For single strings: directly replaces the UUID with the story reference
   * - For arrays: maps through each UUID and replaces with corresponding story references
   */
  _resolveField(e, t, r) {
    const s = e[t];
    typeof s == "string" ? e[t] = this.getStoryReference(r, s) : Array.isArray(s) && (e[t] = s.map(
      (o) => this.getStoryReference(r, o)
    ).filter(Boolean));
  }
  /**
   * Inserts relations into the JSON tree by resolving references
   * @param jtree - The JSON tree object to process
   * @param treeItem - The current field being processed
   * @param fields - The relation patterns to resolve (string or array of strings)
   * @param resolveId - The unique identifier for the current resolution context
   *
   * This method handles two types of relation patterns:
   * 1. Nested relations: matches fields that end with the current field name
   *    Example: If treeItem is "event_type", it matches patterns like "*.event_type"
   *
   * 2. Direct component relations: matches exact component.field patterns
   *    Example: "event.event_type" for component "event" and field "event_type"
   *
   * The method supports both string and array formats for the fields parameter,
   * allowing flexible specification of relation patterns.
   */
  _insertRelations(e, t, r, s) {
    if (Array.isArray(r) ? r.find((a) => a.endsWith(`.${t}`)) : r.endsWith(`.${t}`)) {
      this._resolveField(e, t, s);
      return;
    }
    const o = e.component ? `${e.component}.${t}` : t;
    (Array.isArray(r) ? r.includes(o) : r === o) && this._resolveField(e, t, s);
  }
  /**
   * Recursively traverses and resolves relations in the story content tree
   * @param story - The story object containing the content to process
   * @param fields - The relation patterns to resolve
   * @param resolveId - The unique identifier for the current resolution context
   */
  iterateTree(e, t, r) {
    const s = (o, a = "") => {
      if (!(!o || o._stopResolving)) {
        if (Array.isArray(o))
          o.forEach((l, i) => s(l, `${a}[${i}]`));
        else if (typeof o == "object")
          for (const l in o) {
            const i = a ? `${a}.${l}` : l;
            (o.component && o._uid || o.type === "link") && (this._insertRelations(o, l, t, r), this._insertLinks(o, l, r)), s(o[l], i);
          }
      }
    };
    s(e.content);
  }
  async resolveLinks(e, t, r) {
    let s = [];
    if (e.link_uuids) {
      const o = e.link_uuids.length, a = [], l = 50;
      for (let i = 0; i < o; i += l) {
        const h = Math.min(o, i + l);
        a.push(e.link_uuids.slice(i, h));
      }
      for (let i = 0; i < a.length; i++)
        (await this.getStories({
          per_page: l,
          language: t.language,
          version: t.version,
          starts_with: t.starts_with,
          by_uuids: a[i].join(",")
        })).data.stories.forEach(
          (h) => {
            s.push(h);
          }
        );
    } else
      s = e.links;
    s.forEach((o) => {
      this.links[r][o.uuid] = {
        ...o,
        _stopResolving: !0
      };
    });
  }
  async resolveRelations(e, t, r) {
    let s = [];
    if (e.rel_uuids) {
      const o = e.rel_uuids.length, a = [], l = 50;
      for (let i = 0; i < o; i += l) {
        const h = Math.min(o, i + l);
        a.push(e.rel_uuids.slice(i, h));
      }
      for (let i = 0; i < a.length; i++)
        (await this.getStories({
          per_page: l,
          language: t.language,
          version: t.version,
          starts_with: t.starts_with,
          by_uuids: a[i].join(","),
          excluding_fields: t.excluding_fields
        })).data.stories.forEach((h) => {
          s.push(h);
        });
      s.length > 0 && (e.rels = s, delete e.rel_uuids);
    } else
      s = e.rels;
    s && s.length > 0 && s.forEach((o) => {
      this.relations[r][o.uuid] = {
        ...o,
        _stopResolving: !0
      };
    });
  }
  /**
   *
   * @param responseData
   * @param params
   * @param resolveId
   * @description Resolves the relations and links of the stories
   * @returns Promise<void>
   *
   */
  async resolveStories(e, t, r) {
    var s, o;
    let a = [];
    if (this.links[r] = {}, this.relations[r] = {}, typeof t.resolve_relations < "u" && t.resolve_relations.length > 0 && (typeof t.resolve_relations == "string" && (a = t.resolve_relations.split(",")), await this.resolveRelations(e, t, r)), t.resolve_links && ["1", "story", "url", "link"].includes(t.resolve_links) && ((s = e.links) != null && s.length || (o = e.link_uuids) != null && o.length) && await this.resolveLinks(e, t, r), this.resolveNestedRelations)
      for (const l in this.relations[r])
        this.iterateTree(
          this.relations[r][l],
          a,
          r
        );
    e.story ? this.iterateTree(e.story, a, r) : e.stories.forEach((l) => {
      this.iterateTree(l, a, r);
    }), this.stringifiedStoriesCache = {}, delete this.links[r], delete this.relations[r];
  }
  async cacheResponse(e, t, r, s) {
    const o = this.helpers.stringify({ url: e, params: t }), a = this.cacheProvider();
    if (t.version === "published" && e !== "/cdn/spaces/me") {
      const l = await a.get(o);
      if (l)
        return Promise.resolve(l);
    }
    return new Promise(async (l, i) => {
      var h;
      try {
        const d = await this.throttle(
          "get",
          e,
          t,
          s
        );
        if (d.status !== 200)
          return i(d);
        let p = { data: d.data, headers: d.headers };
        if ((h = d.headers) != null && h["per-page"] && (p = Object.assign({}, p, {
          perPage: d.headers["per-page"] ? Number.parseInt(d.headers["per-page"]) : 0,
          total: d.headers["per-page"] ? Number.parseInt(d.headers.total) : 0
        })), p.data.story || p.data.stories) {
          const E = this.resolveCounter = ++this.resolveCounter % 1e3;
          await this.resolveStories(p.data, t, `${E}`);
        }
        t.version === "published" && e !== "/cdn/spaces/me" && await a.set(o, p);
        const b = this.cache.clear === "onpreview" && t.version === "draft" || this.cache.clear === "auto";
        return t.token && p.data.cv && (b && j[t.token] && j[t.token] !== p.data.cv && await this.flushCache(), j[t.token] = p.data.cv), l(p);
      } catch (d) {
        if (d.response && d.status === 429 && (r = typeof r > "u" ? 0 : r + 1, r < this.maxRetries))
          return console.log(
            `Hit rate limit. Retrying in ${this.retriesDelay / 1e3} seconds.`
          ), await this.helpers.delay(this.retriesDelay), this.cacheResponse(e, t, r).then(l).catch(i);
        i(d);
      }
    });
  }
  throttledRequest(e, t, r, s) {
    return this.client.setFetchOptions(s), this.client[e](t, r);
  }
  cacheVersions() {
    return j;
  }
  cacheVersion() {
    return j[this.accessToken];
  }
  setCacheVersion(e) {
    this.accessToken && (j[this.accessToken] = e);
  }
  clearCacheVersion() {
    this.accessToken && (j[this.accessToken] = 0);
  }
  cacheProvider() {
    switch (this.cache.type) {
      case "memory":
        return {
          get(e) {
            return Promise.resolve(O[e]);
          },
          getAll() {
            return Promise.resolve(O);
          },
          set(e, t) {
            return O[e] = t, Promise.resolve(void 0);
          },
          flush() {
            return O = {}, Promise.resolve(void 0);
          }
        };
      case "custom":
        if (this.cache.custom)
          return this.cache.custom;
      default:
        return {
          get() {
            return Promise.resolve();
          },
          getAll() {
            return Promise.resolve(void 0);
          },
          set() {
            return Promise.resolve(void 0);
          },
          flush() {
            return Promise.resolve(void 0);
          }
        };
    }
  }
  async flushCache() {
    return await this.cacheProvider().flush(), this.clearCacheVersion(), this;
  }
}
const Fe = (n = {}) => {
  const { apiOptions: e } = n;
  if (!e || !e.accessToken) {
    console.error(
      "You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication"
    );
    return;
  }
  return { storyblokApi: new He(e) };
}, Ge = (n) => {
  if (typeof n != "object" || typeof n._editable > "u")
    return {};
  try {
    const e = JSON.parse(
      n._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, "")
    );
    return e ? {
      "data-blok-c": JSON.stringify(e),
      "data-blok-uid": `${e.id}-${e.uid}`
    } : {};
  } catch {
    return {};
  }
};
function Me(n, e) {
  if (!e)
    return { src: n, attrs: {} };
  let t = 0, r = 0;
  const s = {}, o = [];
  function a(i, h, d, p, b) {
    typeof i != "number" || i <= h || i >= d ? console.warn(`[StoryblokRichText] - ${p.charAt(0).toUpperCase() + p.slice(1)} value must be a number between ${h} and ${d} (inclusive)`) : b.push(`${p}(${i})`);
  }
  if (typeof e == "object") {
    if (typeof e.width == "number" && e.width > 0 ? (s.width = e.width, t = e.width) : console.warn("[StoryblokRichText] - Width value must be a number greater than 0"), e.height && typeof e.height == "number" && e.height > 0 ? (s.height = e.height, r = e.height) : console.warn("[StoryblokRichText] - Height value must be a number greater than 0"), e.loading && ["lazy", "eager"].includes(e.loading) && (s.loading = e.loading), e.class && (s.class = e.class), e.filters) {
      const { filters: i } = e || {}, { blur: h, brightness: d, fill: p, format: b, grayscale: E, quality: y, rotate: S } = i || {};
      h && a(h, 0, 100, "blur", o), y && a(y, 0, 100, "quality", o), d && a(d, 0, 100, "brightness", o), p && o.push(`fill(${p})`), E && o.push("grayscale()"), S && [0, 90, 180, 270].includes(e.filters.rotate || 0) && o.push(`rotate(${S})`), b && ["webp", "png", "jpeg"].includes(b) && o.push(`format(${b})`);
    }
    e.srcset && (s.srcset = e.srcset.map((i) => {
      if (typeof i == "number")
        return `${n}/m/${i}x0/${o.length > 0 ? `filters:${o.join(":")}` : ""} ${i}w`;
      if (Array.isArray(i) && i.length === 2) {
        const [h, d] = i;
        return `${n}/m/${h}x${d}/${o.length > 0 ? `filters:${o.join(":")}` : ""} ${h}w`;
      } else {
        console.warn("[StoryblokRichText] - srcset entry must be a number or a tuple of two numbers");
        return;
      }
    }).join(", ")), e.sizes && (s.sizes = e.sizes.join(", "));
  }
  let l = `${n}/m/`;
  return t > 0 && r > 0 && (l = `${l}${t}x${r}/`), o.length > 0 && (l = `${l}filters:${o.join(":")}`), {
    src: l,
    attrs: s
  };
}
var T = /* @__PURE__ */ ((n) => (n.DOCUMENT = "doc", n.HEADING = "heading", n.PARAGRAPH = "paragraph", n.QUOTE = "blockquote", n.OL_LIST = "ordered_list", n.UL_LIST = "bullet_list", n.LIST_ITEM = "list_item", n.CODE_BLOCK = "code_block", n.HR = "horizontal_rule", n.BR = "hard_break", n.IMAGE = "image", n.EMOJI = "emoji", n.COMPONENT = "blok", n.TABLE = "table", n.TABLE_ROW = "tableRow", n.TABLE_CELL = "tableCell", n.TABLE_HEADER = "tableHeader", n))(T || {}), _ = /* @__PURE__ */ ((n) => (n.BOLD = "bold", n.STRONG = "strong", n.STRIKE = "strike", n.UNDERLINE = "underline", n.ITALIC = "italic", n.CODE = "code", n.LINK = "link", n.ANCHOR = "anchor", n.STYLED = "styled", n.SUPERSCRIPT = "superscript", n.SUBSCRIPT = "subscript", n.TEXT_STYLE = "textStyle", n.HIGHLIGHT = "highlight", n))(_ || {}), J = /* @__PURE__ */ ((n) => (n.TEXT = "text", n))(J || {}), x = /* @__PURE__ */ ((n) => (n.URL = "url", n.STORY = "story", n.ASSET = "asset", n.EMAIL = "email", n))(x || {});
const Ue = [
  "area",
  "base",
  "br",
  "col",
  "embed",
  "hr",
  "img",
  "input",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], Be = (n = {}) => Object.keys(n).map((e) => `${e}="${n[e]}"`).join(" "), ze = (n = {}) => Object.keys(n).map((e) => `${e}: ${n[e]}`).join("; ");
function De(n) {
  return n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
const L = (n) => Object.fromEntries(Object.entries(n).filter(([e, t]) => t !== void 0));
function G(n, e = {}, t) {
  const r = Be(e), s = r ? `${n} ${r}` : n, o = Array.isArray(t) ? t.join("") : t || "";
  if (n) {
    if (Ue.includes(n))
      return `<${s}>`;
  } else return o;
  return `<${s}>${o}</${n}>`;
}
function Ve(n = {}) {
  const e = /* @__PURE__ */ new Map(), {
    renderFn: t = G,
    textFn: r = De,
    resolvers: s = {},
    optimizeImages: o = !1,
    keyedResolvers: a = !1
  } = n, l = t !== G, i = () => ({ render: (c, u = {}, g) => {
    if (a && c) {
      const f = e.get(c) || 0;
      e.set(c, f + 1), u.key = `${c}-${f}`;
    }
    return t(c, u, g);
  } }), h = (c) => (u, g) => {
    const f = u.attrs || {};
    return g.render(c, f, u.children || null);
  }, d = (c, u) => {
    const { src: g, alt: f, title: v, srcset: $, sizes: k } = c.attrs || {};
    let w = g, R = {};
    if (o) {
      const { src: re, attrs: se } = Me(g, o);
      w = re, R = se;
    }
    const te = {
      src: w,
      alt: f,
      title: v,
      srcset: $,
      sizes: k,
      ...R
    };
    return u.render("img", L(te));
  }, p = (c, u) => {
    const { level: g, ...f } = c.attrs || {};
    return u.render(`h${g}`, f, c.children);
  }, b = (c, u) => {
    var g, f, v, $;
    const k = u.render("img", {
      src: (g = c.attrs) == null ? void 0 : g.fallbackImage,
      alt: (f = c.attrs) == null ? void 0 : f.alt,
      style: "width: 1.25em; height: 1.25em; vertical-align: text-top",
      draggable: "false",
      loading: "lazy"
    });
    return u.render("span", {
      "data-type": "emoji",
      "data-name": (v = c.attrs) == null ? void 0 : v.name,
      "data-emoji": ($ = c.attrs) == null ? void 0 : $.emoji
    }, k);
  }, E = (c, u) => u.render(
    "pre",
    c.attrs || {},
    u.render("code", {}, c.children || "")
  ), y = (c, u = !1) => ({ text: g, attrs: f }, v) => {
    const { class: $, id: k, ...w } = f || {}, R = u ? {
      class: $,
      id: k,
      style: ze(w) || void 0
    } : f || {};
    return v.render(c, L(R), g);
  }, S = (c) => N(c), I = (c) => {
    const { marks: u, ...g } = c;
    if ("text" in c) {
      if (u)
        return u.reduce(
          (v, $) => S({ ...$, text: v }),
          S({ ...g, children: g.children })
        );
      const f = c.attrs || {};
      if (a) {
        const v = e.get("txt") || 0;
        e.set("txt", v + 1), f.key = `txt-${v}`;
      }
      return r(g.text, f);
    }
    return "";
  }, B = (c, u) => {
    const { linktype: g, href: f, anchor: v, ...$ } = c.attrs || {};
    let k = "";
    switch (g) {
      case x.ASSET:
      case x.URL:
        k = f;
        break;
      case x.EMAIL:
        k = `mailto:${f}`;
        break;
      case x.STORY:
        k = f, v && (k = `${k}#${v}`);
        break;
      default:
        k = f;
        break;
    }
    const w = { ...$ };
    return k && (w.href = k), u.render("a", w, c.text);
  }, Y = (c, u) => {
    var g, f;
    return console.warn("[StoryblokRichtText] - BLOK resolver is not available for vanilla usage"), u.render("span", {
      blok: (g = c == null ? void 0 : c.attrs) == null ? void 0 : g.body[0],
      id: (f = c.attrs) == null ? void 0 : f.id,
      style: "display: none"
    });
  }, W = (c, u) => {
    const g = {}, f = u.render("tbody", {}, c.children);
    return u.render("table", g, f);
  }, X = (c, u) => {
    const g = {};
    return u.render("tr", g, c.children);
  }, Q = (c, u) => {
    const { colspan: g, rowspan: f, colwidth: v, backgroundColor: $, ...k } = c.attrs || {}, w = {
      ...k
    };
    g > 1 && (w.colspan = g), f > 1 && (w.rowspan = f);
    const R = [];
    return v && R.push(`width: ${v}px;`), $ && R.push(`background-color: ${$};`), R.length > 0 && (w.style = R.join(" ")), u.render("td", L(w), c.children);
  }, Z = (c, u) => {
    const { colspan: g, rowspan: f, colwidth: v, backgroundColor: $, ...k } = c.attrs || {}, w = {
      ...k
    };
    g > 1 && (w.colspan = g), f > 1 && (w.rowspan = f);
    const R = [];
    return v && R.push(`width: ${v}px;`), $ && R.push(`background-color: ${$};`), R.length > 0 && (w.style = R.join(" ")), u.render("th", L(w), c.children);
  }, ee = new Map([
    [T.DOCUMENT, h("")],
    [T.HEADING, p],
    [T.PARAGRAPH, h("p")],
    [T.UL_LIST, h("ul")],
    [T.OL_LIST, h("ol")],
    [T.LIST_ITEM, h("li")],
    [T.IMAGE, d],
    [T.EMOJI, b],
    [T.CODE_BLOCK, E],
    [T.HR, h("hr")],
    [T.BR, h("br")],
    [T.QUOTE, h("blockquote")],
    [T.COMPONENT, Y],
    [J.TEXT, I],
    [_.LINK, B],
    [_.ANCHOR, B],
    [_.STYLED, y("span", !0)],
    [_.BOLD, y("strong")],
    [_.TEXT_STYLE, y("span", !0)],
    [_.ITALIC, y("em")],
    [_.UNDERLINE, y("u")],
    [_.STRIKE, y("s")],
    [_.CODE, y("code")],
    [_.SUPERSCRIPT, y("sup")],
    [_.SUBSCRIPT, y("sub")],
    [_.HIGHLIGHT, y("mark")],
    [T.TABLE, W],
    [T.TABLE_ROW, X],
    [T.TABLE_CELL, Q],
    [T.TABLE_HEADER, Z],
    ...Object.entries(s).map(([c, u]) => [c, u])
  ]);
  function A(c) {
    const u = ee.get(c.type);
    if (!u)
      return console.error("<Storyblok>", `No resolver found for node type ${c.type}`), "";
    const g = i();
    if (c.type === "text")
      return u(c, g);
    const f = c.content ? c.content.map(N) : void 0;
    return u({
      ...c,
      children: f
    }, g);
  }
  function N(c) {
    return c.type === "doc" ? l ? c.content.map(A) : c.content.map(A).join("") : Array.isArray(c) ? c.map(A) : A(c);
  }
  return {
    render: N
  };
}
let M, U = "https://app.storyblok.com/f/storyblok-v2-latest.js";
const Je = (n, e, t = {}) => {
  var r;
  const s = !(typeof window > "u") && typeof window.storyblokRegisterEvent < "u", o = new URL((r = window.location) == null ? void 0 : r.href).searchParams.get(
    "_storyblok"
  ), a = o !== null && +o === n;
  if (!(!s || !a)) {
    if (!n) {
      console.warn("Story ID is not defined. Please provide a valid ID.");
      return;
    }
    window.storyblokRegisterEvent(() => {
      new window.StoryblokBridge(t).on(["input", "published", "change"], (l) => {
        var i;
        l && (l.action === "input" && ((i = l.story) == null ? void 0 : i.id) === n ? e(l.story) : (l.action === "change" || l.action === "published") && l.storyId === n && window.location.reload());
      });
    });
  }
}, K = (n, e) => {
  n.addNode("blok", (t) => {
    let r = "";
    return t.attrs.body.forEach((s) => {
      r += e(s.component, s);
    }), {
      html: r
    };
  });
}, Ke = (n = {}) => {
  var e, t;
  const {
    bridge: r,
    accessToken: s,
    use: o = [],
    apiOptions: a = {},
    richText: l = {},
    bridgeUrl: i
  } = n;
  a.accessToken = a.accessToken || s;
  const h = { bridge: r, apiOptions: a };
  let d = {};
  o.forEach((b) => {
    d = { ...d, ...b(h) };
  }), i && (U = i);
  const p = !(typeof window > "u") && ((t = (e = window.location) == null ? void 0 : e.search) == null ? void 0 : t.includes("_storyblok_tk"));
  return r !== !1 && p && V(U), M = new P(l.schema), l.resolver && K(M, l.resolver), d;
}, qe = (n) => {
  var e;
  return !n || !((e = n == null ? void 0 : n.content) != null && e.some((t) => t.content || t.type === "blok" || t.type === "horizontal_rule"));
}, Ye = (n, e, t) => {
  let r = t || M;
  if (!r) {
    console.error(
      "Please initialize the Storyblok SDK before calling the renderRichText function"
    );
    return;
  }
  return qe(n) ? "" : (e && (r = new P(e.schema), e.resolver && K(r, e.resolver)), r.render(n, {}, !1));
}, We = () => V(U);
export {
  T as BlockTypes,
  _ as MarkTypes,
  P as RichTextResolver,
  Ce as RichTextSchema,
  J as TextTypes,
  Fe as apiPlugin,
  qe as isRichTextEmpty,
  We as loadStoryblokBridge,
  Je as registerStoryblokBridge,
  Ye as renderRichText,
  Ve as richTextResolver,
  Ge as storyblokEditable,
  Ke as storyblokInit,
  Je as useStoryblokBridge
};
